import Styled from "styled-components";

export type ArticleLayoutVariant = "standard" | "grid";

export interface IllustrationContainerProps {
  $articleLayoutVariant?: ArticleLayoutVariant;
}

export interface LinkProps {
  $articleLayoutVariant?: ArticleLayoutVariant;
}

export interface IllustrationProps {
  $articleLayoutVariant?: ArticleLayoutVariant;
}

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }
  
  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    align-items: flex-start;
  }
`;

export const IllustrationContainer = Styled.div<IllustrationContainerProps>`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  overflow: hidden;

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 1.5rem;
    flex-flow: row;

    ${(props) =>
      props.$articleLayoutVariant === "grid" &&
      `
      display: grid;
      align-items: center;
      justify-content: space-between;
      grid-template: "a a b" 1fr "a a c" 1fr / 1fr 1fr 1fr;
      gap: 1em;
      width: 100%;

      :nth-child(1) {
        grid-area: a;
        align-self: stretch;
      }

      :nth-child(2) {
        grid-area: b;
      }

      :nth-child(3) {
        grid-area: c;
      }
    `}
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 2rem;
  }
`;

export const Illustration = Styled.div<IllustrationProps>`
  width: 100%;
  height: 100%;
  border-radius: 0.321rem;
  overflow: hidden;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 0px 20px;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
  
  &:after {
    display: flex;
    justify-content: center;
    align-items: center;
    content: "Read more";
    font-weight: bold;
    color: #FFFFFF;
    font-size: 1.5rem;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    transition: all 0.3s ease 0s;
  }

  &:hover:after {
    opacity: 1;
  }
`;

export const Link = Styled.a<LinkProps>`
  cursor: pointer;
`;
